<template>
  <Sheet>
    <template #leading>
      <Sheet.Button
        :icon="isRootFolder ? CloseIcon : ChevronLeftIcon"
        @click="handleLeading"
      />
    </template>
    <template #title>{{ currentFolderName }}</template>
    <template #trailing>
      <Sheet.Button
        variant="primary"
        :icon="CheckmarkIcon"
        :disabled="disableAction"
        @click="handleConfirm"
      />
    </template>

    <div class="relative flex min-h-0 flex-1 flex-col">
      <Sheet.Body class="px-0!">
        <div
          v-if="loading"
          class="flex h-full items-center justify-center py-10"
        >
          <Spinner :size="20" />
        </div>

        <template v-else-if="folders.length">
          <template v-for="(folder, index) in folders" :key="folder.id">
            <button
              type="button"
              class="flex h-16 w-full items-center gap-4 px-4 text-left"
              :class="{
                'pointer-events-none opacity-50': shouldDisableFolder(folder),
              }"
              @click="handleFolderClick(folder)"
            >
              <div class="w-10 shrink-0">
                <Thumbnail type="folder" />
              </div>
              <p
                class="truncate font-secondary text-[16px] leading-[20px] text-gray-800"
              >
                {{ folder.name }}
              </p>
            </button>
            <div
              v-if="index < folders.length - 1"
              class="ml-[72px] mr-4 h-px bg-gray-800/10"
            />
          </template>
        </template>

        <div
          v-else
          class="flex h-full items-center justify-center py-10 font-secondary text-[14px] text-gray-500"
        >
          Move here
        </div>
      </Sheet.Body>

      <button
        type="button"
        class="absolute bottom-4 left-4 flex size-[50px] items-center justify-center rounded-full bg-white text-gray-800 shadow-[0_4px_18px_0_rgba(0,0,0,0.12)]"
        @click="handleNewFolderClick"
      >
        <FolderAddIcon class="size-6" />
      </button>
    </div>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, Thumbnail, useSheet } from '@dacr/library'
import {
  CloseIcon,
  ChevronLeftIcon,
  CheckmarkIcon,
  FolderAddIcon,
} from '@dacr/icons'
import Spinner from '@/shared/components/Spinner.vue'
import { useMoveItems } from './useMoveItems'

const { close } = useSheet()

const props = defineProps<{
  ids: string[]
}>()

const {
  loading,
  folders,
  currentFolderName,
  isRootFolder,
  disableAction,
  shouldDisableFolder,
  handleFolderClick,
  handleBack,
  handleNewFolderClick,
  handleConfirm,
} = useMoveItems(props.ids, close)

const handleLeading = () => (isRootFolder.value ? close() : handleBack())
</script>
